<template>
	<div class="b-cont">
		<div>
			<!-- 法律文书 -->
			<sections
				class="b-cells" 
				title="法律文书" 
				m-color="#46CDCF" 
				content-height="auto"
				:show-save="false">
				<flexbox
					:gutter="0" 
					wrap="wrap" 
					style="padding:10px 8px;margin-top:5px">
					<el-table
						:data="fileList"
						stripe
						border
						:header-cell-style="{'background-color':'#f6faff'}"
						style="width: 100%">
						<el-table-column prop="name" label="文件名">
							<template slot-scope="scope">
								<a
									:href="scope.row.file_path"
									target="_blank"
									style="display: block;">{{scope.row.name}}</a>
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="create_user_id[0].username" label="创建人"></el-table-column>
						<el-table-column prop="create_time" label="创建时间"></el-table-column>
					</el-table>
				</flexbox>
			</sections>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import Sections from '../../customer/Sections'
	import {
		getfilenum
	} from '@/api/lawcase/lawcase'
	export default {
		components: {
			Sections
		},
		data() {
			return {
				fileList:[],
			}
		},
		props: {
			/** 模块ID */
			id: [String, Number],
			/** 没有值就是全部类型 有值就是当个类型 */
			crmType: {
				type: String,
				default: ''
			}
		},
		watch: {
			id: function(val) {
				this.getInfo()
			}
		},
		computed: {
			...mapGetters(['allAuth'])
		},
		mounted() {
			this.$bus.$on("refresh-detail",()=>{
			   this.getInfo()
			})
			this.getInfo()
		},
		methods: {
			// 获取基础信息
			getInfo() {
				getfilenum({
						id: this.id
					})
					.then(res => {
						if(res.data){
							this.fileList = JSON.parse(JSON.stringify(res.data))
						}else{
							this.fileList = []
						}
					})
					.catch(() => {})
			}
		},
	}
</script>

<style scoped>
	/deep/ .el-table{
		font-size: 12px;
	}
</style>